import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from '@app/app.module';
import { environment } from '@environment/environment';
import { AppInjector } from '@app/services/app-injector.service';
import * as Sentry from '@sentry/angular';

if (environment.production) {
  enableProdMode();
}

const environments = [
  ['pre', 'staging'],
  ['site', 'production'],
  ['localhost', 'devel'],
] as const;

const sentryTunnel =
  window.location.protocol === 'https:' && environment.sentry_tunnel.startsWith('/') ? `https://${window.location.host}${environment.sentry_tunnel}` : environment.sentry_tunnel;

function loadAnalytics(): void {
  if (!environment.production || document.querySelector('script[data-site-analytics]')) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-6ZBDE3HFS9';
  script.dataset.siteAnalytics = 'true';
  document.head.appendChild(script);

  const dataLayer = (window as Window & { dataLayer?: unknown[] }).dataLayer || [];
  (window as Window & { dataLayer?: unknown[] }).dataLayer = dataLayer;
  const gtag = (...args: unknown[]): void => {
    dataLayer.push(args);
  };
  gtag('js', new Date());
  gtag('config', 'UA-184894007-1');
}

loadAnalytics();

if (environment.sentry_enable) {
  Sentry.init({
    environment: (() => {
      const hostname = window.location.hostname;
      return environments.find(([value]) => hostname.includes(value))?.[1] ?? 'desconocido';
    })(),
    dsn: environment.sentry_dsn,
    // Eventos enviados vía proxy nginx → evita adblockers y oculta el DSN en network tab
    // nginx-config.yaml: location /proxy/sentry/ → https://logapp.deipe.com/
    tunnel: sentryTunnel,
    release: Object.getOwnPropertyDescriptor(environment, 'version')?.value || 'desconocido',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.05,
    tracePropagationTargets: [environment.apiURLs.private],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
  });
}

platformBrowser()
  .bootstrapModule(AppModule)
  .then((moduleRef) => {
    AppInjector.setInjector(moduleRef.injector);
  })
  .catch((err) => console.log(err));
